<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <main class="main-content position-relative border-radius-lg">
      <HeaderMenu />
      <div class="container-fluid pt-6" style="min-height: 100vh;">
        <!-- Notificaciones -->
        <div v-for="notification in notifications" :key="notification.id" class="alert position-fixed top-0 end-0 m-3"
          :class="notification.class" role="alert" style="color: white; z-index: 9999; max-width: 360px;">
          {{ notification.message }}
          <button style="font-size: small" type="button" class="btn-close" @click="closeNotification(notification.id)" aria-label="Close"></button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h4 class="mb-0">
                  <i class="fas fa-chart-bar me-2"></i>Informes – {{ esquema.nombre || 'Cargando...' }}
                </h4>
                <router-link :to="`/esquema/${id}`" class="btn btn-sm btn-outline-primary">
                  <i class="fas fa-arrow-left me-1"></i>Volver a la tabla
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!esquema.propiedades || esquema.propiedades.length === 0" class="text-center py-5 text-muted">
          <div v-if="cargando" class="spinner-border text-primary" role="status"></div>
          <p v-else class="mb-0">No hay propiedades definidas en este esquema.</p>
        </div>

        <div v-else class="informes-contenido">
          <!-- Configuración del informe -->
          <div class="row">
            <div class="col-lg-3">
              <div class="card">
                <div class="card-header pb-0">
                  <h6 class="mb-0"><i class="fas fa-cog me-2"></i>Configuración del informe</h6>
                </div>
                <div class="card-body">
                  <!-- Agrupar por (select + lista debajo) -->
                  <label class="form-label fw-bold">Agrupar por</label>
                  <p class="small text-muted mb-2">Elige un campo y se añadirá debajo. En fechas puedes elegir por semana, mes, trimestre o año.</p>
                  <select class="form-select form-select-sm mb-2" v-model="selectAgruparAñadir" @change="añadirAgruparPor">
                    <option value="">— Selecciona un campo —</option>
                    <optgroup v-for="grupo in opcionesAgruparParaSelect" :key="grupo.label" :label="grupo.label">
                      <option v-for="opt in grupo.opciones" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                    </optgroup>
                  </select>
                  <ul class="list-group list-group-flush mb-3" style="max-height: 140px; overflow-y: auto;">
                    <li v-for="(item, idx) in config.agruparPor" :key="idx"
                      class="list-group-item d-flex align-items-center justify-content-between py-2">
                      <span class="small">{{ etiquetaAgruparPor(item) }}</span>
                      <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="quitarAgruparPor(idx)" title="Quitar">
                        <i class="fas fa-times"></i>
                      </button>
                    </li>
                    <li v-if="config.agruparPor.length === 0" class="list-group-item text-muted small py-2">Ningún agrupación</li>
                  </ul>

                  <!-- Campos a mostrar (select + lista debajo) -->
                  <label class="form-label fw-bold">Campos a mostrar</label>
                  <p class="small text-muted mb-2">Elige un campo y cómo mostrarlo (valor, suma, contar, etc.) y se añadirá debajo.</p>
                  <select class="form-select form-select-sm mb-2" v-model="selectCampoAñadir" @change="añadirCampoMostrar">
                    <option value="">— Selecciona un campo —</option>
                    <optgroup v-for="grupo in opcionesCamposParaSelect" :key="grupo.label" :label="grupo.label">
                      <option v-for="opt in grupo.opciones" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                    </optgroup>
                  </select>
                  <ul class="list-group list-group-flush" style="max-height: 200px; overflow-y: auto;">
                    <li v-for="(item, idx) in config.camposAMostrar" :key="idx"
                      class="list-group-item d-flex align-items-center justify-content-between py-2">
                      <span class="small">{{ etiquetaCampoMostrar(item) }}</span>
                      <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="quitarCampoMostrar(idx)" title="Quitar">
                        <i class="fas fa-times"></i>
                      </button>
                    </li>
                    <li v-if="config.camposAMostrar.length === 0" class="list-group-item text-muted small py-2">Ningún campo añadido</li>
                  </ul>

                  <!-- Filtros (mismo estilo que Agrupar por / Campos a mostrar) -->
                  <label class="form-label fw-bold">Filtros</label>
                  <p class="small text-muted mb-2">Opcional. Elige un campo, operador y valor y se añadirá debajo.</p>
                  <select class="form-select form-select-sm mb-2" v-model="propiedadFiltroCampoBD" @change="onPropiedadFiltroChange">
                    <option value="">— Selecciona un campo —</option>
                    <option v-for="p in esquema.propiedades" :key="p.campoBD" :value="p.campoBD">
                      {{ formatearNombre(p.nombre) }}
                    </option>
                  </select>
                  <template v-if="propiedadFiltroSeleccionada">
                    <div class="d-flex gap-1 mb-2">
                      <select class="form-select form-select-sm" style="min-width: 90px;" v-model="operadorFiltroId" @change="onOperadorFiltroChange">
                        <option v-for="op in operadoresFiltroDisponibles" :key="op.id" :value="op.id">{{ op.operator }}</option>
                      </select>
                      <template v-if="operadorFiltroActual?.operator === '□' || operadorFiltroActual?.operator === '▦'">
                        <span class="form-control form-control-sm small text-muted align-self-center">{{ operadorFiltroActual?.operator === '□' ? 'Vacío' : 'No vacío' }}</span>
                      </template>
                      <template v-else-if="operadorFiltroActual?.operator === '<>'">
                        <input type="text" class="form-control form-control-sm flex-grow-1"
                          v-model="valorFiltro"
                          :placeholder="propiedadFiltroSeleccionada.tipo === 'date' ? 'ddmmyy;ddmmyy' : 'mín;máx'"
                          @keyup.enter="añadirFiltroInforme">
                      </template>
                      <template v-else-if="operadorFiltroActual?.operator === '≡'">
                        <input type="text" class="form-control form-control-sm flex-grow-1"
                          v-model="valorFiltro" placeholder="valor1;valor2;valor3"
                          @keyup.enter="añadirFiltroInforme">
                      </template>
                      <template v-else-if="propiedadFiltroSeleccionada.tipo === 'list' && propiedadFiltroSeleccionada.lista_id">
                        <select class="form-select form-select-sm flex-grow-1" v-model="valorFiltro">
                          <option value="">Selecciona un valor</option>
                          <option v-for="v in valoresListaFiltro" :key="v.id" :value="v.descripcion">{{ v.descripcion }}</option>
                        </select>
                      </template>
                      <template v-else-if="propiedadFiltroSeleccionada.tipo === 'date'">
                        <input type="text" class="form-control form-control-sm flex-grow-1"
                          v-model="valorFiltro" placeholder="ddmmyy"
                          @keyup.enter="añadirFiltroInforme">
                      </template>
                      <template v-else>
                        <input type="text" class="form-control form-control-sm flex-grow-1"
                          v-model="valorFiltro"
                          :placeholder="placeholderFiltro(propiedadFiltroSeleccionada.tipo)"
                          @keyup.enter="añadirFiltroInforme">
                      </template>
                      <button type="button" class="btn btn-outline-primary btn-sm py-0 px-1" @click="añadirFiltroInforme"
                        :disabled="(!valorFiltro && operadorFiltroActual?.operator !== '□' && operadorFiltroActual?.operator !== '▦')" title="Añadir">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </template>
                  <ul class="list-group list-group-flush mb-2" style="max-height: 140px; overflow-y: auto;">
                    <li v-for="(f, idx) in filtrosActivos" :key="idx"
                      class="list-group-item d-flex align-items-center justify-content-between py-2">
                      <span class="small">{{ etiquetaFiltro(f) }}</span>
                      <button type="button" class="btn btn-outline-danger btn-sm py-0 px-1" @click="eliminarFiltroInforme(idx)" title="Quitar">
                        <i class="fas fa-times"></i>
                      </button>
                    </li>
                    <li v-if="filtrosActivos.length === 0" class="list-group-item text-muted small py-2">Ningún filtro</li>
                  </ul>

                  <div class="d-flex gap-2 flex-wrap">
                    <button class="btn btn-primary" @click="generarInforme" :disabled="cargando || generandoInforme">
                      <span v-show="generandoInforme" class="spinner-border spinner-border-sm me-1" role="status"></span>
                      <i v-show="!generandoInforme" class="fas fa-play me-1"></i>
                      Generar informe
                    </button>
                    <button v-if="resultadoInforme.length > 0" class="btn btn-success" @click="descargarCSV" title="Descargar en CSV (abre en Excel)">
                      <i class="fas fa-file-csv me-1"></i>Descargar CSV
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resultados -->
            <div class="col-lg-9">
              <div class="card">
                <div class="card-header d-flex align-items-center justify-content-between">
                  <h6 class="mb-0">Resultado del informe</h6>
                  <span v-if="resultadoInforme.length > 0" class="badge bg-light text-dark">{{ resultadoInforme.length }} filas</span>
                </div>
                <div class="card-body p-0">
                  <div v-if="resultadoInforme.length === 0" class="text-center text-muted py-5">
                    Configura agrupaciones y/o resúmenes y pulsa «Generar informe». Los cálculos se realizan en el servidor.
                  </div>
                  <div v-else class="overflow-x-auto informes-tabla-scroll">
                    <InformesTablaResultado :filas="resultadoInforme" :columnas="columnasResultado" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import HeaderMenu from '@/components/HeaderMenu.vue';
import InformesTablaResultado from '@/components/InformesTablaResultado.vue';
import axiosInstance from '@/axios';

export default {
  name: 'InformesView',
  components: { HeaderMenu, InformesTablaResultado },
  setup() {
    const route = useRoute();
    const id = computed(() => route.params.id);
    const esquema = ref({ propiedades: [] });
    const datosInforme = ref([]);
    const cargando = ref(true);
    const generandoInforme = ref(false);

    const config = reactive({
      agruparPor: [],
      camposAMostrar: []
    });
    const selectCampoAñadir = ref('');
    const selectAgruparAñadir = ref('');

    // Filtros (sistema como BuscadorView)
    const filtrosActivos = ref([]);
    const propiedadFiltroCampoBD = ref('');
    const valorFiltro = ref('');
    const operadorFiltroActual = ref(null);
    const operadorFiltroId = ref(null);
    const valoresListasCacheFiltro = ref({});
    const valoresListasPendingFiltro = ref({});
    const filters_operator = [
      { id: 1, label: 'Igual', operator: '=' },
      { id: 2, label: 'Mayor/igual', operator: '>=' },
      { id: 3, label: 'Menor/igual', operator: '<=' },
      { id: 4, label: 'Mayor', operator: '>' },
      { id: 5, label: 'Menor', operator: '<' },
      { id: 6, label: 'Contiene', operator: '@' },
      { id: 7, label: 'Empieza', operator: '[' },
      { id: 8, label: 'Termina', operator: ']' },
      { id: 9, label: 'Entre', operator: '<>' },
      { id: 10, label: 'Diferente', operator: '!=' },
      { id: 11, label: 'No contiene', operator: '!@' },
      { id: 13, label: 'Vacío', operator: '□' },
      { id: 14, label: 'No vacío', operator: '▦' },
      { id: 15, label: 'Listado', operator: '≡' }
    ];
    const filters_comparador_text = [1, 6, 7, 8, 10, 11, 13, 14, 15];
    const filters_comparador_number = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];
    const filters_comparador_date = [1, 2, 3, 4, 5, 9, 10, 13, 14, 15];
    const filters_comparador_list = [1, 10, 13, 14, 15];

    const notifications = ref([]);
    const showNotification = (message, type) => {
      const id = 'n-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      const notification = { id, message, class: type };
      notifications.value.push(notification);
      setTimeout(() => {
        const i = notifications.value.findIndex(n => n.id === id);
        if (i !== -1) notifications.value.splice(i, 1);
      }, 4000);
    };
    const closeNotification = (id) => {
      const i = notifications.value.findIndex(n => n.id === id);
      if (i !== -1) notifications.value.splice(i, 1);
    };

    const propiedadesNumericas = computed(() => {
      if (!esquema.value.propiedades) return [];
      const tipos = ['int', 'decimal', 'decimal2', 'decimal4'];
      return esquema.value.propiedades.filter(p => tipos.includes(p.tipo));
    });

    const opcionesAgruparParaSelect = computed(() => {
      if (!esquema.value.propiedades) return [];
      const grupos = [];
      const valorOpciones = esquema.value.propiedades.map(p => ({
        value: p.campoBD + '|valor',
        label: formatearNombre(p.nombre) + (esFecha(p.tipo) ? ' (fecha completa)' : '')
      }));
      if (valorOpciones.length) grupos.push({ label: 'Por valor', opciones: valorOpciones });
      const fechaProps = esquema.value.propiedades.filter(p => esFecha(p.tipo));
      if (fechaProps.length) {
        const fechaOpciones = fechaProps.flatMap(p => [
          { value: p.campoBD + '|semana', label: formatearNombre(p.nombre) + ' (por semana)' },
          { value: p.campoBD + '|mes', label: formatearNombre(p.nombre) + ' (por mes)' },
          { value: p.campoBD + '|trimestre', label: formatearNombre(p.nombre) + ' (por trimestre)' },
          { value: p.campoBD + '|año', label: formatearNombre(p.nombre) + ' (por año)' }
        ]);
        grupos.push({ label: 'Por fecha (semana/mes/trimestre/año)', opciones: fechaOpciones });
      }
      return grupos;
    });

    const añadirAgruparPor = () => {
      const v = selectAgruparAñadir.value;
      if (!v) return;
      const [campoBD, tipo = 'valor'] = v.split('|');
      config.agruparPor.push({ campoBD, tipo: tipo || 'valor' });
      selectAgruparAñadir.value = '';
    };

    const quitarAgruparPor = (idx) => {
      config.agruparPor.splice(idx, 1);
    };

    const etiquetaAgruparPor = (item) => {
      const prop = esquema.value.propiedades.find(p => p.campoBD === item.campoBD);
      const nombre = prop ? formatearNombre(prop.nombre) : item.campoBD;
      if (item.tipo === 'semana') return nombre + ' (semana)';
      if (item.tipo === 'mes') return nombre + ' (mes)';
      if (item.tipo === 'trimestre') return nombre + ' (trimestre)';
      if (item.tipo === 'año') return nombre + ' (año)';
      return nombre;
    };

    const opcionesCamposParaSelect = computed(() => {
      if (!esquema.value.propiedades) return [];
      const grupos = [];
      const hayAgrupaciones = config.agruparPor.length > 0;

      const valorOpciones = esquema.value.propiedades.map(p => ({
        value: p.campoBD + '|',
        label: formatearNombre(p.nombre)
      }));
      // Mostrar "Como valor" solo cuando NO hay agrupaciones
      if (!hayAgrupaciones && valorOpciones.length) {
        grupos.push({ label: 'Como valor', opciones: valorOpciones });
      }
      const modos = [
        { value: 'sum', label: 'Suma' },
        { value: 'count', label: 'Contar' },
        { value: 'avg', label: 'Promedio' },
        { value: 'min', label: 'Mínimo' },
        { value: 'max', label: 'Máximo' }
      ];
      const resumenOpciones = [];
      // Cuando hay agrupaciones, añadir siempre al principio un contador de registros (count(id))
      if (hayAgrupaciones) {
        resumenOpciones.push({
          value: 'id|count',
          label: 'Contador'
        });
      }
      propiedadesNumericas.value.forEach(p => {
        modos.forEach(m => {
          resumenOpciones.push({
            value: p.campoBD + '|' + m.value,
            label: formatearNombre(p.nombre) + ' (' + m.label + ')'
          });
        });
      });
      // Mostrar "Resumen" solo cuando SÍ hay agrupaciones
      if (hayAgrupaciones && resumenOpciones.length) {
        grupos.push({ label: 'Resumen (numéricos)', opciones: resumenOpciones });
      }
      return grupos;
    });

    const añadirCampoMostrar = () => {
      const v = selectCampoAñadir.value;
      if (!v) return;
      const [campoBD, agregacion = ''] = v.split('|');
      config.camposAMostrar.push({ campoBD, agregacion: agregacion || '' });
      selectCampoAñadir.value = '';
    };

    const quitarCampoMostrar = (idx) => {
      config.camposAMostrar.splice(idx, 1);
    };

    const etiquetaCampoMostrar = (item) => {
      const prop = esquema.value.propiedades.find(p => p.campoBD === item.campoBD);
      const nombre = prop ? formatearNombre(prop.nombre) : item.campoBD;
      // Excepción: el contador global (id|count) debe mostrarse solo como "Contador"
      if (item.campoBD === 'id' && item.agregacion === 'count') {
        return 'Contador';
      }
      if (!item.agregacion) return nombre;
      const modos = { sum: 'Suma', count: 'Contar', avg: 'Promedio', min: 'Mínimo', max: 'Máximo' };
      return nombre + ' (' + (modos[item.agregacion] || item.agregacion) + ')';
    };

    const formatearNombre = (nombre) => {
      if (!nombre) return '';
      return nombre.replace(/_/g, ' ');
    };

    const esFecha = (tipo) => tipo === 'date' || tipo === 'datetime';

    const propiedadFiltroSeleccionada = computed(() => {
      if (!propiedadFiltroCampoBD.value || !esquema.value.propiedades) return null;
      return esquema.value.propiedades.find(p => p.campoBD === propiedadFiltroCampoBD.value) || null;
    });

    const getAvailableOperatorsFiltro = (tipo) => {
      let ids = [];
      if (['text', 'longtext'].includes(tipo)) ids = filters_comparador_text;
      else if (['int', 'integer', 'decimal', 'decimal2', 'decimal4'].includes(tipo)) ids = filters_comparador_number;
      else if (['date', 'datetime'].includes(tipo)) ids = filters_comparador_date;
      else if (tipo === 'list') ids = filters_comparador_list;
      else ids = filters_comparador_text;
      return filters_operator.filter(op => ids.includes(op.id));
    };

    const operadoresFiltroDisponibles = computed(() => {
      if (!propiedadFiltroSeleccionada.value) return [];
      return getAvailableOperatorsFiltro(propiedadFiltroSeleccionada.value.tipo);
    });

    watch(propiedadFiltroSeleccionada, (prop) => {
      if (prop) {
        const ops = getAvailableOperatorsFiltro(prop.tipo);
        if (['int', 'integer', 'decimal', 'decimal2', 'decimal4', 'date', 'datetime'].includes(prop.tipo)) {
          operadorFiltroActual.value = ops.find(op => op.operator === '=') || ops[0];
        } else {
          operadorFiltroActual.value = ops.find(op => op.operator === '@') || ops[0];
        }
        operadorFiltroId.value = operadorFiltroActual.value ? operadorFiltroActual.value.id : null;
        if (prop.lista_id) cargarValoresListaFiltro(prop.lista_id);
      } else {
        operadorFiltroActual.value = null;
        operadorFiltroId.value = null;
      }
      valorFiltro.value = '';
    });

    const onOperadorFiltroChange = () => {
      const op = operadoresFiltroDisponibles.value.find(o => o.id === operadorFiltroId.value);
      if (op) operadorFiltroActual.value = op;
    };

    const getOperatorDisplayFiltro = (op) => (op && op.operator) ? op.operator : '';
    const etiquetaFiltro = (f) => {
      const label = getPropiedadLabelFiltro(f.campo);
      const op = getOperatorDisplayFiltro(f.operador);
      const val = f.valor || (f.operador?.operator === '□' ? 'Vacío' : f.operador?.operator === '▦' ? 'No vacío' : '');
      return val ? `${label} ${op} ${val}` : `${label} ${op}`;
    };
    const placeholderFiltro = (tipo) => {
      if (tipo === 'text' || tipo === 'longtext') return 'Texto';
      if (['int', 'integer'].includes(tipo)) return 'Número entero';
      if (['decimal', 'decimal2', 'decimal4'].includes(tipo)) return 'Número decimal';
      return 'Valor';
    };
    const getPropiedadLabelFiltro = (campoBD) => {
      const p = esquema.value.propiedades && esquema.value.propiedades.find(pr => pr.campoBD === campoBD);
      return p ? formatearNombre(p.nombre) : campoBD;
    };

    const cargarValoresListaFiltro = async (listaId) => {
      if (!listaId || valoresListasCacheFiltro.value[listaId]) return;
      if (valoresListasPendingFiltro.value[listaId]) return valoresListasPendingFiltro.value[listaId];
      const promise = (async () => {
        try {
          const res = await axiosInstance.get(`/api/listas/${listaId}/valores`);
          const valores = res.data?.lista?.valores ?? res.data?.data?.lista?.valores ?? [];
          valoresListasCacheFiltro.value[listaId] = valores;
          return valores;
        } catch (e) {
          valoresListasCacheFiltro.value[listaId] = [];
          return [];
        } finally {
          delete valoresListasPendingFiltro.value[listaId];
        }
      })();
      valoresListasPendingFiltro.value[listaId] = promise;
      return promise;
    };

    const valoresListaFiltro = computed(() => {
      if (!propiedadFiltroSeleccionada.value || !propiedadFiltroSeleccionada.value.lista_id) return [];
      const lid = propiedadFiltroSeleccionada.value.lista_id;
      if (!valoresListasCacheFiltro.value[lid]) {
        cargarValoresListaFiltro(lid);
        return [];
      }
      return valoresListasCacheFiltro.value[lid] || [];
    });

    const añadirFiltroInforme = () => {
      if (!propiedadFiltroSeleccionada.value || !operadorFiltroActual.value) return;
      if (operadorFiltroActual.value.operator !== '□' && operadorFiltroActual.value.operator !== '▦' && !valorFiltro.value) return;
      const exist = filtrosActivos.value.find(
        f => f.campo === propiedadFiltroSeleccionada.value.campoBD &&
             f.operador.id === operadorFiltroActual.value.id &&
             f.valor === valorFiltro.value
      );
      if (exist) {
        showNotification('Este filtro ya está añadido', 'alert-info');
        return;
      }
      filtrosActivos.value.push({
        campo: propiedadFiltroSeleccionada.value.campoBD,
        tipo: propiedadFiltroSeleccionada.value.tipo,
        operador: operadorFiltroActual.value,
        valor: valorFiltro.value || ''
      });
      valorFiltro.value = '';
    };

    const eliminarFiltroInforme = (idx) => {
      filtrosActivos.value.splice(idx, 1);
    };

    const limpiarFiltrosInforme = () => {
      filtrosActivos.value = [];
    };

    const onPropiedadFiltroChange = () => {
      valorFiltro.value = '';
    };

    const cargarEsquema = async () => {
      if (!id.value) return;
      cargando.value = true;
      try {
        const res = await axiosInstance.get('/api/datosesquema/' + id.value);
        esquema.value = res.data.esquema || {};
        if (esquema.value.propiedades) {
          // Sin inicialización extra; agruparPor es lista de { campoBD, tipo }
        }
      } catch (e) {
        console.error(e);
        showNotification('Error al cargar el esquema', 'alert-danger');
      } finally {
        cargando.value = false;
      }
    };

    const columnasResultado = computed(() => {
      const cols = [];
      config.agruparPor.forEach((item) => {
        const prop = esquema.value.propiedades.find(p => p.campoBD === item.campoBD);
        let label = prop ? formatearNombre(prop.nombre) : item.campoBD;
        if (item.tipo === 'semana') label += ' (semana)';
        if (item.tipo === 'mes') label += ' (mes)';
        if (item.tipo === 'trimestre') label += ' (trimestre)';
        if (item.tipo === 'año') label += ' (año)';
        const isDate = !!(prop && esFecha(prop.tipo) && (item.tipo || 'valor') === 'valor');
        cols.push({ key: item.campoBD, label, tipo: 'grupo', campoBD: item.campoBD, isDate });
      });
      (config.camposAMostrar || []).forEach((item) => {
        const { campoBD, agregacion } = item;
        const prop = esquema.value.propiedades.find(p => p.campoBD === campoBD);
        const nombre = prop ? formatearNombre(prop.nombre) : campoBD;
        if (agregacion) {
          // Excepción: el contador global (id|count) debe llamarse solo "Contador"
          if (campoBD === 'id' && agregacion === 'count') {
            cols.push({ key: campoBD + '_' + agregacion, label: 'Contador', agregacion, campoBD, tipo: 'agregacion', isDate: false });
          } else {
            const labelAgg = { sum: 'Suma', count: 'Contar', avg: 'Promedio', min: 'Mín', max: 'Máx' }[agregacion];
            cols.push({ key: campoBD + '_' + agregacion, label: nombre + ' (' + labelAgg + ')', agregacion, campoBD, tipo: 'agregacion', isDate: false });
          }
        } else {
          cols.push({ key: campoBD, label: nombre, campoBD, tipo: 'mostrar', isDate: !!(prop && esFecha(prop.tipo)) });
        }
      });
      return cols;
    });

    const resultadoInforme = computed(() => datosInforme.value);

    const generarInforme = async () => {
      console.log('generarInforme');
      console.log(config.camposAMostrar);
      if (!id.value) return;
      const agruparPor = config.agruparPor.map(item => ({ campo: item.campoBD, tipo: item.tipo || 'valor' }));
      // Enviar todas las columnas de "Campos a mostrar" en agregaciones.
      // Para las que no tienen agregación elegida usamos "valor" como tipo especial.
      const agregaciones = config.camposAMostrar.map(c => ({
        campo: c.campoBD,
        agregacion: c.agregacion || 'valor'
      }));
      const filtros = filtrosActivos.value.map(f => ({
        campo: f.campo,
        tipo: f.tipo,
        operador: f.operador.operator,
        valor: f.valor
      }));
      const body = { agrupar_por: agruparPor, agregaciones, filtros };
      generandoInforme.value = true;
      try {
        const res = await axiosInstance.post('/api/informes/esquema/' + id.value, body);
        // Backend puede devolver: { data: [...] } o { data: { filas: [...] } }
        const raw = res.data?.data?.filas ?? res.data?.filas ?? (Array.isArray(res.data?.data) ? res.data.data : res.data?.data) ?? res.data ?? [];
        const datos = Array.isArray(raw) ? raw : [];
        generandoInforme.value = false;
        // Diferir la asignación al siguiente tick para evitar errores del patcher de Vue (insertBefore)
        setTimeout(() => {
          datosInforme.value = datos;
          if (datos.length === 0 && (config.agruparPor.length || config.camposAMostrar.some(c => c.agregacion))) {
            showNotification('No hay datos para el informe con la configuración actual', 'alert-info');
          } else if (datos.length > 0) {
            showNotification('Informe generado correctamente', 'alert-success');
          }
        }, 0);
      } catch (e) {
        console.error(e);
        generandoInforme.value = false;
        setTimeout(() => {
          datosInforme.value = [];
          showNotification(e.response?.data?.message || 'Error al generar el informe', 'alert-danger');
        }, 0);
      }
    };

    const DECIMALES_NUMERICOS = 2;

    const formatearFechaDDMMYYYY = (valor) => {
      if (valor == null || valor === '') return '';
      const d = new Date(valor);
      if (isNaN(d.getTime())) return valor;
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      return day + '/' + month + '/' + d.getFullYear();
    };

    const formatearValor = (valor, col) => {
      if (col.key === '_etiqueta_' && (valor == null || valor === '')) return 'Total';
      if (valor == null || valor === '') return '—';
      if (col.isDate) return formatearFechaDDMMYYYY(valor) || '—';
      if (col.tipo === 'agregacion' && col.agregacion) {
        const n = Number(valor);
        if (isNaN(n)) return valor;
        if (col.agregacion === 'count') {
          return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
        return n.toLocaleString('es-ES', { minimumFractionDigits: DECIMALES_NUMERICOS, maximumFractionDigits: DECIMALES_NUMERICOS });
      }
      return valor;
    };

    const valorParaCSV = (valor, col) => {
      if (col.key === '_etiqueta_' && (valor == null || valor === '')) return 'Total';
      if (valor == null || valor === '') return '';
      if (col.isDate) return formatearFechaDDMMYYYY(valor);
      if (col.tipo === 'agregacion' && col.agregacion) {
        const n = Number(valor);
        if (isNaN(n)) return valor;
        if (col.agregacion === 'count') return String(Math.round(n));
        return n.toFixed(DECIMALES_NUMERICOS).replace('.', ',');
      }
      const s = String(valor);
      return s.includes(';') || s.includes('"') || s.includes('\n') ? '"' + s.replace(/"/g, '""') + '"' : s;
    };

    const descargarCSV = () => {
      const cols = columnasResultado.value;
      const filas = resultadoInforme.value;
      if (!cols.length || !filas.length) return;
      const sep = ';';
      const header = cols.map(c => (c.label.includes(sep) || c.label.includes('"') ? '"' + c.label.replace(/"/g, '""') + '"' : c.label)).join(sep);
      const lineas = [header];
      filas.forEach(fila => {
        lineas.push(cols.map(c => valorParaCSV(fila[c.key], c)).join(sep));
      });
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + lineas.join('\r\n')], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `informe_${(esquema.value.nombre || id.value || 'informe').replace(/[^a-z0-9]/gi, '_')}_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      showNotification('CSV descargado', 'alert-success');
    };

    onMounted(() => cargarEsquema());

    watch(id, () => cargarEsquema());

    return {
      id,
      esquema,
      cargando,
      config,
      generandoInforme,
      resultadoInforme,
      columnasResultado,
      propiedadesNumericas,
      notifications,
      showNotification,
      closeNotification,
      formatearNombre,
      esFecha,
      generarInforme,
      formatearValor,
      descargarCSV,
      selectCampoAñadir,
      opcionesCamposParaSelect,
      añadirCampoMostrar,
      quitarCampoMostrar,
      etiquetaCampoMostrar,
      selectAgruparAñadir,
      opcionesAgruparParaSelect,
      añadirAgruparPor,
      quitarAgruparPor,
      etiquetaAgruparPor,
      filtrosActivos,
      propiedadFiltroCampoBD,
      propiedadFiltroSeleccionada,
      valorFiltro,
      operadorFiltroActual,
      operadorFiltroId,
      operadoresFiltroDisponibles,
      valoresListaFiltro,
      getOperatorDisplayFiltro,
      etiquetaFiltro,
      placeholderFiltro,
      getPropiedadLabelFiltro,
      añadirFiltroInforme,
      eliminarFiltroInforme,
      limpiarFiltrosInforme,
      onPropiedadFiltroChange,
      onOperadorFiltroChange
    };
  }
};
</script>

<style scoped>
.table th { font-size: 0.7rem; }
.table td { font-size: 0.8rem; }
.informes-tabla-scroll {
  min-width: 0;
  -webkit-overflow-scrolling: touch;
}
</style>
